import { render, staticRenderFns } from "./gl-slot-switcher.vue?vue&type=template&id=48a01fe8&scoped=true"
import script from "./gl-slot-switcher.vue?vue&type=script&lang=js"
export * from "./gl-slot-switcher.vue?vue&type=script&lang=js"
import style0 from "./gl-slot-switcher.vue?vue&type=style&index=0&id=48a01fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a01fe8",
  null
  
)

export default component.exports